<p class="fs-20"><strong>Comunas disponibles</strong></p>
<div mat-dialog-content>
  <p>El servicio Enex Express+ no está disponible en la comuna indicada, recuerda que solo está disponible en las siguientes comunas:</p>

  <div class="row mb-5">
    <div class="col-4" *ngFor="let comuna of data.comunas">{{ comuna.comuna }}</div>
  </div>
  
</div>
<mat-dialog-actions class="text-center">
  <div class="col-12 mb-4">
    <button type="submit" class="btn btn-success btn-md mr-0 mr-md-3 mb-3 px-5 mb-md-0" (click)="cerrarModal()" id="eex-acpter-comunas">
      Aceptar
    </button>
  </div>
</mat-dialog-actions>
